import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';

interface Option {
  value: string;
  label: string;
}

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: Option[];
  placeholder?: string;
  error?: string | null;
}

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { label, options, placeholder, error, className = '', id, ...rest },
  ref,
) {
  const selectId = id ?? `select-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="flex flex-col gap-1">
      {label !== undefined && label !== '' && (
        <label htmlFor={selectId} className="text-xs font-medium text-slate-300">
          {label}
        </label>
      )}
      <select
        ref={ref}
        id={selectId}
        className={`bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 focus:border-floryon-green focus:outline-none focus:ring-1 focus:ring-floryon-green/50 ${className}`}
        {...rest}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error !== undefined && error !== null && error !== '' && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
});
